import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'routes.Festival.Rules.title',
    defaultMessage: 'Campaign Rules',
    description: '备注: 页面title',
  },
})
